import { AxiosResponse } from 'axios';

// Api's
import { IQuoteItemCommentApi } from './base';
import { api } from './base/api';

// Models
import { Result } from '../models/common/resultResponse';
import { QuoteItemCommentRequest } from '../models/request';

// Utils
import {
  QuoteItemCommentHeaderResponse,
  QuoteItemCommentResponse
} from '../models/response';

const baseRoute: string = 'QuoteItemComment';

export class QuoteItemCommentApi extends IQuoteItemCommentApi {
  getCommentsHeaderByQuoteItem(
    guidQuoteItem: string
  ): Promise<AxiosResponse<Result<QuoteItemCommentHeaderResponse>>> {
    return api.get(`${baseRoute}/getcommentsheaderbyquoteitem`, {
      params: { guidQuoteItem }
    });
  }
  getCommentsByQuoteItem(
    guidQuoteItem: string
  ): Promise<AxiosResponse<Result<QuoteItemCommentResponse[]>>> {
    return api.get(`${baseRoute}/getcommentsbyquoteitem`, {
      params: { guidQuoteItem }
    });
  }
  save(request: QuoteItemCommentRequest): Promise<AxiosResponse<Result<any>>> {
    return api.post(`${baseRoute}`, request);
  }
}

